module.exports = __webpack_public_path__ + "img/horizontal_6_7_5.cf83efd7.png";